import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { query } from "lib/graphql/query"

export const getPagedRoles = api(({ searchTerm = "", skip = 0, take = 20, orderStmt, client, type } = {}) =>
    query(
        gql`
            query PagedRoles(
                $searchTerm: String
                $skip: Int
                $take: Int
                $orderStmt: [String]
                $client: String
                $type: String
            ) {
                pagedRoles(
                    searchTerm: $searchTerm
                    skip: $skip
                    take: $take
                    orderStmt: $orderStmt
                    client: $client
                    type: $type
                ) {
                    totalCount
                    pageInfo {
                        endCursor
                        hasNextPage
                        hasPreviousPage
                        startCursor
                    }
                    edges {
                        node {
                            id
                            name
                            description
                            demands
                        }
                        cursor
                    }
                }
            }
        `,
        { searchTerm, skip, take, orderStmt, client, type },
        { returns: "pagedRoles" }
    )
)

export const getRoles = api(({ skip = 0, take = 20, orderStmt, client, type } = {}) =>
    query(
        gql`
            query GetRoles($skip: Int, $take: Int, $orderStmt: [String], $client: String, $type: String) {
                roles(skip: $skip, take: $take, orderStmt: $orderStmt, client: $client, type: $type) {
                    id
                    name
                    description
                    demands
                    type
                }
            }
        `,
        { skip, take, orderStmt, client, type },
        { returns: "roles" }
    )
)

export function useRoles({ client } = {}) {
    const value = getRoles.useResults({ client })
    return value || []
}

export const updateRole = api(({ roleId, roleDemands, roleName, roleDescription, client } = {}) =>
    mutate(
        gql`
            mutation updateRole(
                $roleId: ID!
                $roleDemands: [ID!]!
                $roleName: String
                $roleDescription: String
                $client: String
            ) {
                updateRole(
                    id: $roleId
                    demands: $roleDemands
                    name: $roleName
                    description: $roleDescription
                    client: $client
                ) {
                    demands
                    description
                    name
                }
            }
        `,
        { roleId, roleDemands, roleName, roleDescription, client },
        { returns: "updateRole" }
    )
)

export const createRole = api(({ name, description, demands, client, type } = {}) =>
    mutate(
        gql`
            mutation CreateRole($name: String!, $description: String, $demands: [ID!], $client: String, $type: String) {
                createRole(name: $name, description: $description, demands: $demands, client: $client, type: $type) {
                    description
                    name
                    demands
                    id
                    client
                    type
                }
            }
        `,
        { name, description, demands, client, type },
        { returns: "createRole" }
    )
)

export const deleteRole = api(({ id, client } = {}) =>
    mutate(
        gql`
            mutation DeleteRole($deleteRoleId: ID!, $client: String) {
                deleteRole(id: $deleteRoleId, client: $client)
            }
        `,
        { deleteRoleId: id, client },
        { returns: "deleteRole" }
    )
)
